import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const formName = FormsEnum.SkpRegistrationForm;

export const skpRegistration = {
  onZipCodeChange(initialRun: boolean) {
    zipCodeChange(initialRun, FieldsEnum.SkpRegistrationZipCode, formName);
  },
};
